import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		subformMortgageesComparison_emptyMortgageesContainer: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		subformMortgageesComparison_emptyMortgageesRowContainer: {
			display: 'flex',
			justifyContent: 'center',
			padding: theme.spacing(1.5, 0),
		},
		subformMortgageesComparison_emptyMortgeesIcon: {
			color: theme.palette.grey[500],
			width: theme.spacing(10),
			height: theme.spacing(10),
		},
		subformMortgageesComparison_emptyMortgeesTitle: {
			color: theme.palette.info.main,
			fontSize: theme.spacing(4),
		},
		subformMortgageesComparison_emptyMortgeesSubtitle: {
			color: theme.palette.grey[500],
			fontSize: theme.typography.subtitle2.fontSize,
		},
	});
});

export default useStyles;
